import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const BusinessPlanDetails = () => <OperatorRequestDetails />;

export default BusinessPlanDetails;
